;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';

	var View             = APP.module('View');
	//TODO::Yuri make refactoring base on steps.js files
	View.RegisterRecover = Marionette.ItemView.extend({
		tagName: 'div',

		ui: {
			toNextStep:      '#js-submit-step',
			toPrevStep:      '#js-return-step',
			facebookConnect: '#facebook-connect',
			stateInput:      '.state'
		},

		events: {
			'click @ui.toNextStep':      'checkBeforeNextStep',
			'click @ui.toPrevStep':      'returnToPreviousStep',
			'click @ui.facebookConnect': 'facebookConnect'
		},

		initialize: function (options) {
			this.errors                  = false;
			this.backend_form_validation = [];
			this.form_template           = this.getOption('formTemplate');
			this.countries               = this.getOption('viewData').countries;
			this.states                  = this.getOption('viewData').states;
			this.squads                  = this.getOption('viewData').squads;
			this.model                   = this.getOption('viewData').model;
			this.user                    = this.getOption('viewData').user;

			this.stepButtons = this.getOption('viewData').first_step_buttons;
			var fields       = this.getOption('viewData').register_recover_fields;
			fields           = this.filterFormFields(fields);
			fields           = fields.split(',');

			this.fields = fields;
			fields      = _.map(fields, function (field) {
				return field + ':blur';
			});

			this.getJSONData();

			this.form = new Backbone.Form({
				template:     JST[this.form_template],
				model:        this.model,
				templateData: {
					register_recover_fields: this.fields,
					first_step_buttons:      this.stepButtons,
					submitButton:            false
				}
			});

			this.initListeners(fields);

			$.when.apply(null, this.complete).done(_.bind(function () {
				this.form.data = {
					countryList: this.countries.toJSON(),
					statesList:  this.states.toJSON(),
					squads:      this.squads.toJSON()
				};
				this.render();
			}, this));

		},

		initListeners(fields){
			this.listenTo(this.form, fields.join(' '), this.changeAndBlur);
			this.listenTo(this.form, 'country:change', this.changeCountry);
		},

		filterFormFields: function (fields) {

			var birthday = APP.module('instance').user.get('birthday');

			if (birthday && Boolean(birthday.slice(0, 1))) {
				fields = fields.replace('birthday,', '');
			}

			return fields
		},

		getJSONData: function () {
			var collections = [this.squads, this.states, this.countries];
			this.complete   = _.invoke(collections, 'fetch', {cache: true, expires: 60});
		},

		render: function () {

			/*if(!this.dataLoaded)
			 return;*/

			this.$el.html(this.form.render().el);
			this.changeCountry(this.form, _.first(this.form.fieldsets).fields.country);

			return this;
		},

		validate: function () {
			var errs = this.form.validate();
			//if (errs) {
			//	event.preventDefault();
			//}
		},

		changeAndBlur: function (form, editor) {
			if (!editor.getValue()) {
				$(editor.el).removeClass('valid');
				$(editor.el).parents('.error').removeClass('error');
				$(editor.el).parent().next('div').html('');
				return;
			}
			var errs = this.form.fields[editor.key].validate();
			switch (editor.key) {
				case 'email':
					this.form.fields.confirm_email.validate();
					break;
				case 'password':
					this.form.fields.passwordConfirm.validate();
					break;
				default:
					break;
			}
			!errs && editor.previousValue ? $(editor.el).addClass('valid') : $(editor.el).removeClass('valid');
			return this;
		},

		changeCountry: function (model, item) {
			var toggleParents = (_.bind(function (model, item) {
				var $state_input = $(this.ui.stateInput),
					$parents     = $state_input.parents().eq(2),
					is_val       = item && item.getValue() == 'AU',
					show_or_hide = is_val ? 'show' : 'hide',
					new_val      = is_val ? 'ACT' : '';

				$parents[show_or_hide]();
				$state_input.val(new_val);
			}, this, model, item));
			//TODO::Try to remove settimeout
			setTimeout(toggleParents, 0);
		},

		checkBeforeNextStep: function (event) {
			event.stopPropagation();
			this.showPreloader();
			this.errors = false;

			var err = this.form.validate();

			_.find(this.fields, _.bind(function (value) {
				if (_.has(err, value)) {
					this.scrollToFieldError(value);
					return this.errors = true;
				}
			}, this));

			if (this.errors) {
				this.hidePreloader();
				return this;
			}
			else {

				var formValues   = this.form.getValue();
				var formFields   = this.fields;
				var recover_data = {};
				_.each(formValues, function (value, key) {
					_.find(formFields, function (val) {
						if (val === key) {
							recover_data[key] = value;
						}
					})
				});

				$.when.call(null, this.user.recoverUser(recover_data)).done(_.bind(function (resp) {
					if (resp.errors.length) {
						this.showErrors(resp.errors);
					}
					else {
						APP.vent.trigger('user:login', resp.result);
						//Backbone.history.navigate('/', {trigger : true});
						this.hidePreloader();
					}
				}, this));
				return this;
			}
		},
		scrollToFieldError:  function (val) {
			$('html, body').animate({
				scrollTop: $(this.form.fields[val].el).offset().top
			}, 500);
		}

	});

}(window, APP, Backbone, Marionette, $, _));